import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

interface RelatedPost {
  id: number;
  title: string;
  slug: string;
  image: string;
  category: string;
  readTime: string;
  views: string;
}

interface RelatedPostsProps {
  posts: RelatedPost[];
  currentPostId: number;
}

const RelatedPosts = ({ posts, currentPostId }: RelatedPostsProps) => {
  const filteredPosts = posts.filter(post => post.id !== currentPostId).slice(0, 6);

  return (
    <section className="py-12 sm:py-16 bg-dark-card/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-center gap-2 sm:gap-3 mb-6 sm:mb-8">
          <div className="w-1 h-6 sm:h-8 bg-gradient-gaming"></div>
          <h2 className="font-exo font-bold text-2xl sm:text-3xl text-white">
            BÀI VIẾT LIÊN QUAN
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {filteredPosts.map((post, index) => (
            <motion.article
              key={post.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group bg-dark-card rounded-lg sm:rounded-xl overflow-hidden border border-gray-800 hover:border-accent-cyan/50 transition-all"
            >
              <Link to={`/bai-viet/${post.slug}`} className="block">
                <div className="relative h-40 sm:h-48 overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-dark-card to-transparent"></div>
                  <span className="absolute top-2 sm:top-3 left-2 sm:left-3 px-2 sm:px-3 py-1 bg-gradient-gaming text-white text-[10px] sm:text-xs font-semibold rounded-full">
                    {post.category}
                  </span>
                </div>

                <div className="p-4 sm:p-5">
                  <h3 className="font-exo font-bold text-base sm:text-lg text-white mb-2 sm:mb-3 line-clamp-2 group-hover:text-accent-cyan transition-colors">
                    {post.title}
                  </h3>

                  <div className="flex items-center gap-3 sm:gap-4 text-[10px] sm:text-xs text-gray-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      {post.readTime}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {post.views}
                    </span>
                  </div>
                </div>
              </Link>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RelatedPosts;
